import React, { Component } from 'react';
import css from './Projects.module.scss';
import ProjectItem from './ProjectItem.js';
import ExplorationsList from '../../components/ExplorationsList';

import ImgSheltertech from './assets/ShelterTech.png';
import ImgAskdarcel from './assets/AskDarcel.png';
import ImgBeboTournaments from './assets/BeboTournaments.jpg';
import ImgBeboStreaming from './assets/BeboStreaming.jpg';
import ImgTwitch from './assets/Twitch.png';
import ImgEsportsOne from './assets/EsportsOne.png';
import ImgClimateDashboard from './assets/ClimateDashboard.png';
import ImgUrbanMobility from './assets/UrbanMobility.png';

export default class Projects extends Component {
  state = {
  }

  render () {
      return (
        <div>
          <div className={css.hero}>
             <h1>Derek Fidler</h1>
             <h2>Amsterdam-based senior product designer & product manager</h2>
          </div>
          <div className={css.selectedWork}>
            <header>Selected Work</header>
              <ul className={css.selectedWorkList}>
                <ProjectItem
                  title='Twitch Mobile'
                  description='Positioning Twitch as the premier destination for mobile gamers'
                  position='Senior Product Designer'
                  img={ImgTwitch}
                  link='Twitch'
                />
                <ProjectItem
                  title='Esports One Design System'
                  description='Figma design system for an esports startup'
                  position='Freelance Product Designer'
                  img={ImgEsportsOne}
                  link='EsportsOne'
                />
                <ProjectItem
                  title='Climate Impact Dashboard'
                  description='B2B pivot for an Amsterdam-based green startup'
                  position='Freelance Product Manager & Designer'
                  img={ImgClimateDashboard}
                  link='ClimateDashboard'
                />
                <ProjectItem
                  title='Urban Mobility App'
                  description='EV ridesharing app and vehicle designs'
                  position='Freelance Product & Brand Designer'
                  img={ImgUrbanMobility}
                  link='UrbanMobility'
                />

                <ProjectItem
                  title='Bebo Tournaments'
                  description='Esports for Everybody'
                  position='Product Designer & Installation Design'
                  img={ImgBeboTournaments}
                  link='BeboTournaments'
                />
                <ProjectItem
                  title='Bebo Streaming Software'
                  description='Next gen streaming software'
                  position='Product Designer & Apparel Design'
                  img={ImgBeboStreaming}
                  link='BeboStreaming'
                />
                <ProjectItem
                  title='Sheltertech'
                  description='Solving the biggest tech challenges faced by the homeless'
                  position='Co-Founder & Executive Board Member'
                  img={ImgSheltertech}
                  link='Sheltertech'
                />
                <ProjectItem
                  title='AskDarcel'
                  description='Housing and human services directory'
                  position='Program Manager & Product Designer'
                  img={ImgAskdarcel}
                  link='Askdarcel'
                />

              </ul>
          </div>
          <ExplorationsList />
        </div>
      )
   }
}
